import React, {useContext, useEffect, useRef, useState} from "react";
import LineChart from "./chart/LineChart";
import Socket, {waitForOpenSocket} from "./Socket";
import {getChartConfig} from "./chart/config";
import UlopolisTabs from "./UlopolisTabs";
import {ChartContext} from "./chart/providers";
import {ChartContainer} from "./chart/components";
import {SettingsContext} from "./providers";


export default function App() {
    const minutes = 1440

    const [chart, setChart] = useState(undefined);
    const [active, setActive] = useState(undefined);
    const settings = useContext(SettingsContext)

    const days = isNaN(parseInt(settings.days)) ? 1 : parseInt(settings.days)

    const chartRef = useRef();
    const socketWrapper = new Socket(settings.uri, settings.source)

    useEffect(() => {
        const chartConfig = getChartConfig(settings)
        let activeChartId = Object.keys(chartConfig)[0]
        if (window.location.hash && window.location.hash.replace('#', '') in chartConfig) {
            activeChartId = window.location.hash.replace('#', '');
        }

        const chart = new LineChart(chartRef.current.getContext('2d'), chartConfig, minutes / 10, days)
        activeChartId = activeChartId in chartConfig ? activeChartId : Object.keys(chartConfig)[0]
        chart.setActive(activeChartId);
        setChart(chart);
        setActive(activeChartId);

        const ws = socketWrapper(chart);

        const getInitialData = async () => {
            await waitForOpenSocket(ws)
            const start = new Date();
            start.setMinutes(start.getMinutes() - minutes * days - 10);
            const payload = {
                'source': settings.source,
                'end': new Date().toISOString(),
                'start': start.toISOString(),
            }

            for(const type of settings.measurement_types) {
                ws.send(JSON.stringify({...payload, 'type': type}))
            }
        }

        getInitialData().catch(console.error);

        return () => {
            chart.destroy();
            ws.close();
        }
    }, [])

    return (
        <ChartContext.Provider value={{chart, active, setActive}}>
            <div className={'ulopolis-chart-container'}>
                <UlopolisTabs />
                <ChartContainer ref={chartRef} />
            </div>
        </ChartContext.Provider>

    )
}
